import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import Button from "./controls/Button";
import NotListedLocationIcon from "@material-ui/icons/NotListedLocation";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ExitConfirmDialog(props) {
  const { exitDialog, setExitDialog } = props;
  const classes = useStyles();
  const { t } = useTranslation("forms");

  return (
    <Dialog open={exitDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>
        <IconButton disableRipple className={classes.titleIcon}>
          <NotListedLocationIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{exitDialog.text}</Typography>
        {/* <Typography variant="h6">{"Yau have data in table... Are you still want to log out"}</Typography> */}
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          text={t("confirm-no")}
          color="default"
          onClick={() => setExitDialog({ ...exitDialog, isOpen: false })}
        />
        <Button
          text={t("confirm-yes")}
          color="secondary"
          onClick={exitDialog.onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
}
